export default "__VITE_ASSET__CiK$v8vo__"